const config = {
  production: true,
  development: false,

  functionHostKey: 'BWzmt/TwOiHoyoBlQtP7LmNUfbMnnExIiFnsUEHgjVi/5UuiPpXkKA==',
  publicFunctionHostKey:
    'cHJjdyoQ7r7qT7GgvndSy4Qfu15Dwfg7/ewHqkYJSuFDaCNmA5WSBg==',

  privateApiRoot: 'https://bahnkick-private-api.azurewebsites.net/api',
  publicApiRoot: 'https://bahnkick-api.azurewebsites.net/api',

  signalRHubUrl: 'https://bahnkick-signalr.azurewebsites.net/api',

  LOG_ROCKET_KEY: '8kox0k/bahnkick-partner',

  whatsnewUrl: 'https://partner.bahnkick.com/whatsnew',
};

export default config;
